import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Rekprof logo",
  class: "logo_min",
  src: "../../../../assets/logo.png"
}, null, -1)
const _hoisted_2 = { class: "inner_step_box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, "3. Доверенность", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, " Предлагаем Вам воспользоваться услугой формирования доверенности. Данные указанные в ней автоматически отобразятся в необходимых для заполнения полях заявления ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "hint_left unselectable",
  style: {"margin-bottom":"9px"}
}, " Выбрать доверенность ", -1)
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_menu_list = _resolveComponent("v-menu-list")!
  const _component_v_select_open = _resolveComponent("v-select-open")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_v_menu_list),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      (_openBlock(), _createBlock(_component_v_select_open, {
        options: _ctx.storeDM.save_obj.proxy_options,
        title_select: _ctx.storeDM.save_obj.proxy_name,
        onChangeSelect: _ctx.proxy_select,
        z_index: 1,
        margin_top: '-9px',
        key: _ctx.storeDM.save_obj.proxy_id
      }, null, 8, ["options", "title_select", "onChangeSelect"]))
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "white_s_btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.go_back()))
    }, "Назад"),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["next_btn", { active_btn: _ctx.step_next }]),
      disabled: !_ctx.step_next,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.go_next()))
    }, " Далее ", 10, _hoisted_9)
  ], 64))
}